function clearCart() {
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      // Update cart count
      document.querySelector('[data-header-cart-count]').textContent = '0';
      
      // Add empty class to cart form
      document.getElementById('cart').classList.add('cart--empty');
      
      // Add empty class to cart sidebar
      if (document.getElementById('site-cart-sidebar')) {
        document.getElementById('site-cart-sidebar').classList.add('cart-is-empty');
      }
      
      // Hide elements with hide-if-empty-cart class
      document.querySelectorAll('.hide-if-empty-cart').forEach(element => {
        element.style.display = 'none';
      });
      
      // Disable clear cart button
      const clearCartBtn = document.querySelector('.cart__clear-button button');
      if (clearCartBtn) {
        clearCartBtn.disabled = true;
      }
      
      // Refresh the page to update cart state
      window.location.reload();
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('Failed to clear cart. Please try again.');
    });
}
